var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripadvisorReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 19.56772,
    y1: 18.46775,
    x2: 82.53269,
    y2: 83.70856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6e0bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34841,
    stopColor: "#55e0a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#34e0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#348b7f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.32311,42.8471l4.36204-4.74577h-9.67321c-4.84263-3.30793-10.69105-5.23447-17.016-5.23447-6.31695,0-12.14904,1.93069-16.98367,5.23447h-9.69742l4.36204,4.74577c-2.67372,2.43946-4.34988,5.95338-4.34988,9.85499,0,7.36295,5.9696,13.33244,13.33255,13.33244,3.49772,0,6.68436-1.34897,9.06332-3.55426l4.27317,4.65285,4.27317-4.6488c2.37896,2.20529,5.56155,3.55021,9.05927,3.55021,7.36295,0,13.34055-5.96949,13.34055-13.33244.00395-3.90566-1.6721-7.41949-4.34593-9.85499ZM36.6635,61.72499c-4.98409,0-9.02289-4.03881-9.02289-9.02289s4.03891-9.02299,9.02289-9.02299,9.02289,4.03891,9.02289,9.02299-4.0389,9.02289-9.02289,9.02289ZM50,52.43956c0-5.93727-4.31756-11.03434-10.01651-13.21136,3.08167-1.28848,6.46225-2.00334,10.01245-2.00334s6.93474.71486,10.01651,2.00334c-5.6948,2.18107-10.01245,7.27419-10.01245,13.21136ZM63.33255,61.72499c-4.98409,0-9.02299-4.03881-9.02299-9.02289s4.03891-9.02299,9.02299-9.02299,9.02289,4.03891,9.02289,9.02299-4.0389,9.02289-9.02289,9.02289ZM41.39306,52.7021c0,2.61313-2.11642,4.72955-4.72955,4.72955s-4.72955-2.11642-4.72955-4.72955,2.11642-4.72965,4.72955-4.72965c2.61313-.00405,4.72955,2.11642,4.72955,4.72965Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.8902,50.71872l-2.60743-.52107-1.30132-2.31886c-.28435-.5066-1.01361-.5066-1.2979,0l-1.30132,2.31886-2.60743.52107c-.56969.11384-.79506.80739-.40109,1.23435l1.80323,1.95417-.31022,2.64083c-.06777.57698.52223,1.00568,1.05001.76288l2.41574-1.11107,2.4158,1.11107c.52778.2428,1.11773-.1859,1.04995-.76288l-.31016-2.64083,1.80323-1.95417c.39397-.42696.1686-1.12051-.40109-1.23435Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripadvisorReviewsScraper);
export default __webpack_public_path__ + "static/media/tripadvisor-reviews-scraper.03938f52c1ed6e3212cc4fedaff6f956.svg";
export { ForwardRef as ReactComponent };